<template>
  <Transition name="fade">
    <div class="modal-outer-wrapper" v-if="visible">
      <div class="modal-background" @click="$emit('close')"></div>
      <div class="modal-wrapper" :style="getStyle()">
        <div class="modal-header">
          <h1>{{ heading }}</h1>
          <span v-html="getSVG('times')" @click="$emit('close')" />
        </div>
        <slot />
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.modal-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--son-schwarz);
  opacity: .4;
  z-index: 10000;
}

.modal-outer-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;
}

.modal-wrapper {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 30px;
  z-index: 10500;
  min-width: 400px;
  max-width: calc(100% - 40px);
  max-height: calc(100vh - 40px);
  overflow-y: auto;
}

.modal-header {
  padding-right: 30px;
}

.modal-header :deep(svg) {
  position: absolute;
  right: 20px;
  top: 20px;
  width: 20px;
  height: auto;
  cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>

<script>
export default {
  data() {
    return {}
  },
  emits: [
    "close",
  ],
  props: [
    "visible",
    "heading",
    "width",
  ],
  methods: {
    getStyle() {
      return {
        width: this.width || "auto",
      }
    }
  }
}
</script>